import { render, staticRenderFns } from "./Resorts.vue?vue&type=template&id=70cf98e8&"
import script from "./Resorts.vue?vue&type=script&lang=js&"
export * from "./Resorts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports